import { useEffect, useState } from "react";
import { ProgressLine } from "../../atoms";

const style = {
    width: 100,
    display: 'inline-block',
};

const Gauge = ({ series, value, vertical }) => {
    const [color, setColor] = useState('');
    const [percent, setPercent] = useState(0);

    useEffect(() => {
        function handleValue() {
            setPercent(value / 500 * 100);

            if (value <= 50) {
                setColor('#5aff07');
            } else if (value <= 100) {
                setColor('#c3ff0d');
            } else if (value <= 200) {
                setColor('#ffd814');
            } else if (value <= 300) {
                setColor('#ff791a');
            } else if (value <= 500) {
                setColor('#ff2121');
            }
        }
        handleValue();
        return () => {
            setColor('');
            setPercent(0);
        };
    }, [value]);

    return (
        <div style={style}>
            <ProgressLine percent={percent} color={color} vertical={true} />
        </div>
    );
}

export default Gauge;